
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class FirmwareDiagramEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const spacing = (300 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1.5 * scale;

        const drawComponent = (x: number, y: number, s: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.globalAlpha *= 0.4;
             ctx.strokeRect(-s/2, -s/3, s, s * 0.6);
             ctx.beginPath();
             ctx.moveTo(0, s/3); ctx.lineTo(0, s * 0.5);
             ctx.stroke();
             
             // Flow bits
             const pulse = (Math.sin(time * 3 + x) + 1) * 0.5;
             ctx.fillStyle = pc.color;
             ctx.beginPath();
             ctx.rect(-s/4, -s/10, s/2 * pulse, 5 * scale);
             ctx.fill();
             ctx.restore();
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                for (let y = y1; y <= y2; y += spacing) {
                    drawComponent(x, y, spacing * 0.7 * scale);
                    // Connector lines
                    ctx.beginPath();
                    ctx.moveTo(x + spacing * 0.35, y);
                    ctx.lineTo(x + spacing * 0.65, y);
                    ctx.stroke();
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
